export default "assets/images/icons/wine-nez-9e525728.svg";